import {useDocument} from '../../firebase/hooks/useDocument';
import {Document} from '../../firebase/types';
import {SignupRule} from '#common/auth/rules';
import {SignupList, SignupRuleType} from '#common/firebase/collections';

export function useSignupRuleDocument(type: SignupRuleType, id: string): Document<SignupRule> {
  return useDocument<SignupRule>(SignupList[type], id);
}
